/**
 * The full-screen moments a Save can earn (SCORZA-110). At most one per save,
 * first in priority order, and never twice for the same match.
 */
export type SaveMoment = "hatTrick" | "cleanSheet";

export interface MatchOutcome {
    goals: number;
    goalkeeper: boolean;
    conceded: number;
    // The user has already been through the post-match details form
    confirmed: boolean;
}

const cleanSheet = (m: MatchOutcome) => m.goalkeeper && m.conceded === 0;

export const earnedMoment = (
    before: MatchOutcome,
    after: MatchOutcome
): SaveMoment | undefined => {
    if (before.goals < 3 && after.goals >= 3) return "hatTrick";
    // A recorded 0 is already true on the first save, so that save counts
    if (cleanSheet(after) && !(before.confirmed && cleanSheet(before))) {
        return "cleanSheet";
    }
    return undefined;
};
